/**
 * Product mockup used in the hero and the pricing card.
 * While empty, a code-drawn cover in the product identity is shown.
 */
export const PRODUCT_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/qK2DET7FutSpqKC6wGJCvf/Photorealistic-product-mockup-wide-comp.png'

export const PRODUCT_MOCKUP_ALT =
  'Rec Gymnastics Class-Ready: A Full Year of Done-for-You Lesson Plans & Skill Progressions — six volumes for recreational gymnastics coaches'

export const PRODUCT_NAME = 'Rec Gymnastics Class-Ready'

/** Where the pricing button sends the coach. TODO: confirm the real checkout URL. */
export const CHECKOUT_URL = 'https://rec-gymnastics-class-ready.impultienda.ar/checkout'
